module.exports = __webpack_public_path__ + "static/img/gongliyiyuan.8dbd0f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gongliyiyuan.png
// module id = ED+u
// module chunks = 1